import {css} from 'styled-components'

import {BodySelector} from '@/src/config/settings'
import theme, {media} from '@/src/config/theme'

export const AntdStyled = css`
  .ant-image-preview {
    img {
      width: auto;
      height: 100%;
    }
  }

  .ant-breadcrumb {
    span {
      font-weight: 450;
    }
  }

  .ant-breadcrumb ol {
    align-items: center;
  }

  .ant-tooltip .ant-tooltip-inner {
    min-height: unset !important;
  }

  ${BodySelector} {
    .ant-modal-root {
      position: relative;
      //z-index: 2003;
    }

    .ant-tooltip {
      position: relative;
      //z-index: 2003 !important;
    }

    .ant-float-btn {
      bottom: 90px;
      z-index: 2003;
    }

    .ant-picker-dropdown {
      inset: calc(100% + 2px) 0 0 0 !important;
    }

    .ant-picker-date-panel {
      max-width: calc(100vw - 20px);

      @media ${media.md} {
        max-width: inherit;
      }
    }
  }

  ${BodySelector} .header-menu,
  ${BodySelector} .ant-dropdown-menu-submenu {
    .ant-dropdown-menu.ant-dropdown-menu-vertical {
      overflow-y: auto;
      max-height: 200px;
    }

    .ant-dropdown-menu {
      min-width: 150px;
      border: solid 1px ${theme.colors.borderColorAlpha};
      border-radius: 5px;
    }

    .ant-dropdown-menu-item-group-list,
    .ant-dropdown-menu-item,
    .ant-dropdown-menu-submenu-title {
      padding: unset;
      margin: unset;
    }

    .ant-dropdown-menu,
    .ant-dropdown-menu-submenu {
      background-color: ${theme.colors.bgDark};

      .ant-dropdown-menu,
      .ant-dropdown-menu-sub {
        background-color: transparent;
      }
    }

    .ant-dropdown-menu .ant-dropdown-menu-item-group-title,
    .ant-dropdown-menu-submenu-title {
      color: ${theme.colors.textDark};
    }

    .ant-dropdown-menu .ant-dropdown-menu-item-group-title {
      opacity: 0.8;
    }

    .ant-dropdown-menu,
    .ant-dropdown-menu,
    .ant-dropdown-menu-submenu {
      .ant-dropdown-menu-title-content,
      .ant-dropdown-menu-title-content a,
      .ant-dropdown-menu-submenu-title {
        .ant-dropdown-menu-submenu-arrow {
          svg {
            color: ${theme.colors.white};
          }
        }

        align-items: center;

        color: ${theme.colors.textDark};

        &:hover {
          color: ${theme.colors.text};

          .ant-dropdown-menu-submenu-arrow {
            svg {
              color: ${theme.colors.text};
            }
          }
        }
      }

      .ant-dropdown-menu-title-content {
        padding: 10px;

        &:hover {
          background: ${theme.colors.primary};
          color: ${theme.colors.text};

          a,
          * {
            color: ${theme.colors.text};
          }
        }
      }
    }
  }

  ${BodySelector} .ant-select-dropdown {
    width: auto;
  }
`
